import mainStore from '@components/Main/store'
import { TOP_BANNER_HEIGHT } from '@constant'
import { getObjValue } from '@hlj/hlj-utils'
import { isHotelProperty } from '@merchant-backend/util'
import { getMerchantInfo } from '@util'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Store from './store'
import styles from './style.module.less'
@observer
export default class extends Component {
  constructor() {
    super()
    this.store = new Store()
  }
  render() {
    const { step, changeStep, finishGuide } = this.store
    const { posterStore } = mainStore
    const { hasBannerPoster } = posterStore
    const { new_guidelines = [] } = getMerchantInfo()

    return (
      <div className={styles.layer}>
        <div
          className={styles.step1}
          style={{ display: step == 1 ? 'block' : 'none' }}
        >
          <div
            className={styles.inner}
            style={{ top: hasBannerPoster ? TOP_BANNER_HEIGHT + 46 : 46 }}
          >
            <img
              src="https://qnm.hunliji.com/FoHDrIMa9hnoGMbyIo4Ez2W-dpn_"
              width={56}
            />
            <div className={styles.box}>
              <p>小犀的温馨提示：查看新手指引，带您快速熟悉后台功能！</p>
              <div className={styles.btn} onClick={changeStep('2')}>
                马上查看
              </div>
            </div>
          </div>
        </div>

        <div
          className={styles.step2}
          style={{ display: step == 2 ? 'block' : 'none' }}
        >
          <div
            className={styles.inner}
            style={{ top: hasBannerPoster ? TOP_BANNER_HEIGHT + 106 : 106 }}
          >
            {isHotelProperty() ? (
              <img
                src="https://qnm.hunliji.com/FphyMRslwlF0uRGWelc5Tq4fcFOs"
                width={88}
              />
            ) : (
              <img
                src="https://qnm.hunliji.com/FpRcDLeoyZUvIIIt_05XHcTfkeRf"
                width={88}
              />
            )}
            <div className={styles.wrap}>
              <div className={styles.triangle} />
              <div className={styles.box}>
                <p>{getObjValue(new_guidelines[0], 'content')}</p>
                <div className={styles.btn} onClick={changeStep('3')}>
                  下一步(1/3)
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={styles.step3}
          style={{ display: step == 3 ? 'block' : 'none' }}
        >
          <div
            className={styles.inner}
            style={{ top: hasBannerPoster ? TOP_BANNER_HEIGHT + 154 : 154 }}
          >
            <img
              src="https://qnm.hunliji.com/FpPwf0el9kxNLM-kgnndWn7CprVE"
              width={88}
            />
            <div className={styles.wrap}>
              <div className={styles.triangle} />
              <div className={styles.box}>
                <p>{getObjValue(new_guidelines[1], 'content')}</p>
                <div className={styles.btn} onClick={changeStep('4')}>
                  下一步(2/3)
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={styles.step4}
          style={{ display: step == 4 ? 'block' : 'none' }}
        >
          <div className={styles.inner}>
            <div className={styles.wrap}>
              <div className={styles.box}>
                <p>{getObjValue(new_guidelines[2], 'content')}</p>
                <div className={styles.btn} onClick={finishGuide}>
                  知道了(3/3)
                </div>
              </div>
              <div className={styles.triangle} />
            </div>
            <div className={styles.icon}>
              <img src="http://qnm.hunliji.com/o_1c4lha5od11sobvst3r13o61rdh8.png" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
